import log from "loglevel";
import { ErrorResponseType } from "types";

export const bodylessServiceResponse = (
  response: Response
): ErrorResponseType => {
  return {
    error: {
      success: false,
      message: "Unable to process request",
      status: response.status,
    },
  };
};

export const unauthorizedServiceResponse = (
  response: Response
): ErrorResponseType => {
  return {
    error: { success: false, message: "Unauthorized", status: response.status },
  };
};

export const processServiceResponse = (
  response: Response,
  endpoint?: string
): any => {
  if (response.ok) {
    log.info(`${endpoint}: GOOD REQUEST!`);
  } else if (response.status == 401) {
    log.warn(`${endpoint}: UNAUTHORIZED REQUEST!`);
    throw unauthorizedServiceResponse(response);
  } else if (response.json() == undefined) {
    log.warn(`${endpoint}: BAD REQUEST WITH NO BODY!`);
    throw bodylessServiceResponse(response);
  } else {
    log.warn(`${endpoint}: BAD REQUEST!`);
    throw response.json();
  }
  return response.json();
};
